"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderForm;
exports.loadDocument = loadDocument;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
const baseUri = 'https://solidos.github.io/profile-pane/src/ontology/';
function renderForm(div, subject,
// Represents the RDF that fills the form
formSource,
// The imported form Turtle source
formName,
// The name of the form file (e.g., 'socialMedia.ttl')
store, dom, editableProfile, whichForm) {
  // Optional: specify which form to use if multiple 'a ui:Form' are present in the file{
  // --- Form resource setup ---
  const formUri = baseUri + formName; // Full URI to the form file
  const exactForm = whichForm || 'this'; // If there are more 'a ui:Form' elements in a form file
  const formThis = (0, _rdflib.Namespace)(formUri + '#')(exactForm); // NamedNode for #this in the form

  loadDocument(store, formSource, formName, formUri);
  _solidUi.widgets.appendForm(dom, div, {}, subject, formThis, editableProfile, (ok, mes) => {
    if (!ok) _solidUi.widgets.errorMessageBlock(dom, mes);
  });
} // renderForm

// we need to load into the store some additional information about Social Media accounts
function loadDocument(store, documentSource, documentName, documentURI) {
  const finalDocumentUri = documentURI || baseUri + documentName; // Full URI to the file
  const document = (0, _rdflib.sym)(finalDocumentUri); // rdflib NamedNode for the document    

  if (!store.holds(undefined, undefined, undefined, document)) {
    // we are using the social media form because it contains the information we need
    // the form can be used for both use cases: create UI  for edit and render UI for display
    (0, _rdflib.parse)(documentSource, store, finalDocumentUri, 'text/turtle', () => null); // Load doc directly
  }
}